import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import moment from 'moment';
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function VentaSalderos() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_TALLAS = process.env.REACT_APP_URL_TALLAS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COMPRADORES = process.env.REACT_APP_URL_COMPRADORES;
  const URL_PEDIDOS_CLIENTE = process.env.REACT_APP_URL_PEDIDOS_CLIENTE;
  const URL_ARTICULOS_PEDIDO_CLIENTE = process.env.REACT_APP_URL_ARTICULOS_PEDIDO_CLIENTE;
  const URL_SOCIEDADES = process.env.REACT_APP_URL_SOCIEDADES;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  // let hoy = new Date()
  // let inicio = new Date()
  // inicio.setDate(inicio.getDate()-30);
 
  // let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  // let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [selectedArea, setSelectedArea] = useState("");
  const [areas, setAreas] = useState([]);
  const [inventarios, setInventarios] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [colores, setColores] = useState([]);
  const [tallas, setTallas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [pedidoCliente, setPedidoCliente] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [comprador, setComprador] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [value, setValue] = useState("");

  const [idArticulo, setIdArticulo] = useState("");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  const [fecha, setFecha] = useState(hoy);
  const [fecha_cancelacion, setFechaCancelacion] = useState("");
  const [fecha_confirmacion, setFechaConfirmacion] = useState("");
  const [observaciones, setObservaciones] = useState("NA");
  const [total_general, setTotalGeneral] = useState(0);
  const [total_piezas, setTotalPiezas] = useState(0);
  const [empresas, setEmpresas] = useState([]);
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [compradores, setCompradores] = useState([]);
  const [selectedComprador, setSelectedComprador] = useState("");
  const [sociedades, setSociedades] = useState([]);
  const [selectedSociedad, setSelectedSociedad] = useState("");
    const [selectedImpuesto, setSelectedImpuesto] = useState(0);

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      articulos: "",
      tallas: "",
      colores: "",
      cantidad: 0,
      precio: 0,
      total: 0,
      articulosNombre: ""
    },
  ]);

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
        axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allAreas = res.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
    if(selectedArea)
    axios
      .get(`${URL_INVENTARIOS}/ventaSalderos/${selectedArea}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allInventarios = res.data;
        setInventarios(allInventarios);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allArticulos = res.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColores = res.data;
        setColores(allColores);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_TALLAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allTallas = res.data;
        setTallas(allTallas);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allColaboradores = res.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_EMPRESAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allEmpresa = response.data;
          setEmpresas(allEmpresa);
          //
        })
        .catch((err) => {
          console.log(err);
        });
        axios
          .get(URL_COMPRADORES, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allCompradores = res.data;
            setCompradores(allCompradores);
          })
          .catch((err) => {
            console.log(err);
          });
          axios
          .get(URL_SOCIEDADES, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allSociedades = res.data;
            setSociedades(allSociedades);
          })
          .catch((err) => {
            console.log(err);
          });
  }, [selectedArea]);


console.log("hola2", value._id)

  const savePedido = async (event) => {
    event.preventDefault();
        if (value._id != "") {
          setValidaBoton(false);
          toggleProgreso();
          let totalPedido = inputFields.length;
          try {


            let iva = 0;
let impuestos = 0;
let subTotal = total_general;
let totalConIVA = total_general;
let saldo = total_general;

if (selectedImpuesto == 16) {
  iva = parseFloat((total_general * 0.16).toFixed(2));
  impuestos = 16;
  totalConIVA = parseFloat((total_general * 1.16).toFixed(2));
  saldo = totalConIVA;
}

            await axios
              .post(
                URL_PEDIDOS,
                {
                  fecha,
                  fechaCreacion: hoy,
                  resurtido: "No",
                  empresas: selectedEmpresa,
                  clientes: value._id,
                  colaboradores: selectedColaborador,
                  fecha_cancelacion: hoy,
                  fecha_confirmacion: hoy,
                  total_general,
                  total_piezas,
                  compradores: "6776c839c763d45da2f0f5b7",
                  observaciones,
                  articulos: "684a00e8f1c666acbb0e02f7",
                  pedidoCliente: "NA",
                  surtido: total_piezas,
                  pendiente_surtir: 0,
                  confirmacionPedido: "No",
                  status: "Cerrado",
                  fechaEstCodigos: hoy,
                  fechaEstFicha: hoy,
                  fechaEstAuditoria: hoy,
                  fechaEstMuestraFit: hoy,
                  fechaEstMuestraConfirmacion: hoy,
                  fechaEstEtiquetas: hoy,
                  fechaRealCodigos: hoy,
                  fechaRealFicha: hoy,
                  fechaRealAuditoria: hoy,
                  fechaRealMuestraFit: hoy,
                  fechaRealMuestraConfirmacion: hoy,
                  fechaRealEtiquetas: hoy,
                  autorizacionFitFecha: hoy,
                  autorizacionCostosFecha: hoy,
                  autorizacionDisenoFecha: hoy,
                  autorizacionCalidadFecha: hoy,
                  autorizacionPloterFecha: hoy,
                  autorizacionPloterDisenoFecha: hoy,
                  autorizacionSurtirFecha: hoy,

                  autorizacionFitColaborador: "613a9434225bce3df050c220",
                  autorizacionCostosColaborador: "613a9434225bce3df050c220",
                  autorizacionDisenoColaborador: "613a9434225bce3df050c220",
                  autorizacionCalidadColaborador: "613a9434225bce3df050c220",
                  autorizacionPloterColaborador: "613a9434225bce3df050c220",
                  autorizacionPloterDisenoColaborador: "613a9434225bce3df050c220",
                  autorizacionSurtirColaborador: "613a9434225bce3df050c220",
                  descuento: 0,
                  sociedades: selectedSociedad,
                  pendFechaConf: "No"
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem(
                      "app_token"
                    )}`,
                  },
                }
              )
              .then(async (dataPedido) => {
                await axios
                  .post(
                    URL_SURTIDOS,
                    {
                      fecha,
                      pedidos: dataPedido.data._id,
                      observaciones,
                      numeroFactura: "NA",
                      user: user.id,
                      clientes: value._id,
                      areas: selectedArea,
                      total_general: totalConIVA,
                      saldo,
                      subTotal,
                      iva,
                      impuestos,
                      is_active: "Si",
                      empresas: selectedEmpresa,
                      descuento: 0,
                      descuento2: 0,
                      totalCantidad: total_piezas,
                      articulos: "684a00e8f1c666acbb0e02f7",
                      precio: 0,
                      facturado: "No",
                      colaboradores: selectedColaborador,
                      sociedades: selectedSociedad,
                      ventaSalderos: "Si"
                    },
                    {
                      headers: {
                        Authorization: `Bearer: ${localStorage.getItem(
                          "app_token"
                        )}`,
                      },
                    }
                  )
                  .then((dataSurt) => {
                    inputFields.map((a) => {
                      if (a.articulos != "" && a.cantidad != 0) {
                        axios
                          .post(
                            URL_ARTICULOS_PEDIDO,
                            {
                              pedidos: dataPedido.data._id,
                              articulos: a.articulos,
                              colores: a.colores,
                              tallas: a.tallas,
                              cantidad: parseFloat(a.cantidad),
                              pendienteCortar: parseFloat(a.cantidad),
                              cortado: 0,
                              surtido: 0,
                              pendiente_surtir: parseFloat(a.cantidad),
                              cantidad_procesos: parseFloat(a.cantidad),
                              precio: parseFloat(a.precio),
                              descuento: 0,
                              total: (
                                parseFloat(a.cantidad) * parseFloat(a.precio)
                              ).toFixed(2),
                              codigoBarras: 0,
                              precioEtiqueta: 0,
                              resurtido: "No",
                              codigoCliente: "NA",
                              sociedades: selectedSociedad,
                            },
                            {
                              headers: {
                                Authorization: `Bearer: ${localStorage.getItem(
                                  "app_token"
                                )}`,
                              },
                            }
                          )
                          .then((dataArtPed) => {
                            axios
                              .post(
                                URL_ARTICULOS_SURTIDOS,
                                {
                                  surtidos: dataSurt.data._id,
                                  inventarios: a.idInv,
                                  cantidad: parseFloat(a.cantidad),
                                  articulos: a.articulos,
                                  pedidos: dataPedido.data._id,
                                  articulosPedido: dataArtPed.data._id,
                                  areas: selectedArea,
                                  tallas: a.tallas,
                                  colores: a.colores,
                                  facturado: "No",
                                  // colorFactura: a.color,
                                  sociedades: selectedSociedad,
                                },
                                {
                                  headers: {
                                    Authorization: `Bearer: ${localStorage.getItem(
                                      "app_token"
                                    )}`,
                                  },
                                }
                              )

                              .then((data) => {
                                totalPedido = totalPedido - 1;
                                if (totalPedido == 0) {
                                  axios
                                    .post(
                                      URL_LOGS,
                                      {
                                        tipo: "Crear Pedido",
                                        detalle: `${value._id} ${total_general}`,
                                        user: user.id,
                                      },
                                      {
                                        headers: {
                                          Authorization: `Bearer: ${localStorage.getItem(
                                            "app_token"
                                          )}`,
                                        },
                                      }
                                    )
                                    .then(() => {
                                      Swal.fire(
                                        "Good job!",
                                        "Creado con exito",
                                        `success`
                                      );
                                      setTimeout(() => {
                                        window.location.reload();
                                      }, 1000);
                                    });
                                }
                              })
                              .catch((error) => {
                                Swal.fire({
                                  icon: "error",
                                  title: "Oops...",
                                  text: "Something went wrong!",
                                  // footer: `${error.response.data}`,
                                });
                                console.log(error);
                                setValidaBoton(true);
                              });
                          });
                      } else {
                        totalPedido = totalPedido - 1;
                        if (totalPedido == 0) {
                          axios
                            .post(
                              URL_LOGS,
                              {
                                tipo: "Crear Pedido",
                                detalle: `${value._id} ${total_general}`,
                                user: user.id,
                              },
                              {
                                headers: {
                                  Authorization: `Bearer: ${localStorage.getItem(
                                    "app_token"
                                  )}`,
                                },
                              }
                            )
                            .then(() => {
                              Swal.fire(
                                "Good job!",
                                "Creado con exito",
                                `success`
                              );
                              setTimeout(() => {
                                window.location.reload();
                              }, 1000);
                            });
                        }
                      }
                    });
                  })
                  .catch((error) => {
                    Swal.fire({
                      icon: "error",
                      title: "Oops...",
                      text: "Something went wrong!",
                      // footer: `${error.response.data}`,
                    });
                    console.log(error);
                    setValidaBoton(true);
                  });
              })
              .catch((error) => {
                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: "Something went wrong!",
                  footer: `${error.response.data}`,
                });
                console.log(error);
                setValidaBoton(true);
              });
          } catch (error) {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          }
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Faltan datos, favor de revisar",
          });
        }
  };

const handleAddFields = () => {
  const ultimo = inputFields[inputFields.length - 1];

  setInputFields([
    ...inputFields,
    {
      id: uuidv4(),
      articulos: ultimo.articulos,
      articulosNombre: ultimo.articulosNombre,
      combinaciones: ultimo.combinaciones || [],
      disponible: ultimo.disponible || 0,
      idInv: "", // Se reinicia al seleccionar talla/color
      tallas: "",
      colores: "",
      cantidad: 0,
      precio: ultimo.precio,
      total: 0,
    },
  ]);
};

console.log("hola", inputFields)
  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let cantidad = inputFields.map((c) => parseFloat(c.cantidad));
    let TC = cantidad.reduce((t, total, index) => t + total, 0);
    setTotalPiezas(TC);

    let importes = values.map((c) => parseFloat(c.total));
    let TG = importes.reduce((t, total, index) => t + total, 0);
    setTotalGeneral(TG);
  };

const handleChangeInput = (id, event) => {
  const { name, value } = event.target;

  setInputFields((prevFields) => {
    const nuevosCampos = prevFields.map((field) => {
      if (field.id === id) {
        let nuevo = { ...field, [name]: value };

        // Conversión de cantidad y precio a número
        if (name === "cantidad") {
          const cantidadNum = parseFloat(value) || 0;
          const disponible = parseFloat(field.disponible) || 0;
          nuevo.cantidad = cantidadNum > disponible ? disponible : cantidadNum;
        }

        if (name === "precio") {
          nuevo.precio = parseFloat(value) || 0;
        }

        // Recalcular total
        nuevo.total = parseFloat(nuevo.cantidad || 0) * parseFloat(nuevo.precio || 0);

        // Actualizar idInv y disponible si cambia talla o color
        if (name === "tallas" || name === "colores") {
          const combinacion = (field.combinaciones || []).find(
            (c) =>
              c.idColor === (name === "colores" ? value : nuevo.colores) &&
              c.idTalla === (name === "tallas" ? value : nuevo.tallas)
          );

          if (combinacion) {
            nuevo.idInv = combinacion.idInventario;
            nuevo.disponible = combinacion.cantidad || 0;
          } else {
            nuevo.idInv = "";
            nuevo.disponible = 0;
          }

          // Validar que la cantidad no supere el nuevo disponible
          const cant = parseFloat(nuevo.cantidad) || 0;
          const max = parseFloat(nuevo.disponible) || 0;
          nuevo.cantidad = cant > max ? max : cant;
          nuevo.total = nuevo.cantidad * parseFloat(nuevo.precio || 0);
        }

        return nuevo;
      }
      return field;
    });

    // 👉 Llama a ActualizaTotales después de actualizar el estado
    setTimeout(() => {
      ActualizaTotales(nuevosCampos);
    }, 0);

    return nuevosCampos;
  });
};









  // const handleChangeInputCantidad = (id, colores, tallas, event) => {
  //   const newInputFields = inputFields.map((i) => {
  //     if (id === i.id) {
  //       i[event.target.name] = event.target.value;

  //       let can = i.tc.map((c) => parseFloat(c.cantidad));
  //       let TC = can.reduce((t, total, index) => t + total, 0);

  //       i.total = parseFloat(i.cantidad) * parseFloat(i.precio);
  //     }
  //     return i;
  //   });
  //   setInputFields(newInputFields);

  //   ActualizaTotales();
  // };

function BuscaArticulo(id, selectedArticulo) {
  const idArticulo = selectedArticulo.idArticulo;
  const codigo = selectedArticulo.codigo;

  const item = inventarios.find((inv) => inv.idArticulo === idArticulo);

  const combinaciones = item?.combinaciones || [];

  const newInputFields = inputFields.map((i) => {
    if (i.id === id) {
      return {
        ...i,
        articulos: idArticulo,
        articulosNombre: codigo,
        precio: 0,
        combinaciones,
        colores: "",
        tallas: "",
        idInv: "",
      };
    }
    return i;
  });

  setInputFields(newInputFields);
  ActualizaTotales();
}







  const handleChangeInputArticulo = (
    id,
    idArticulo,
    precio,
    articulosNombre
  ) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.articulos = idArticulo;
        let totalParcial = i.cantidad * i.precio;
        i.total = totalParcial;
        i.precio = precio;
        i.articulosNombre = articulosNombre
      }
      return i;
    });
    setInputFields(newInputFields);

    ActualizaTotales();
  };

const ActualizaTotales = (fields = inputFields) => {
  const piezas = fields.reduce((sum, f) => sum + parseFloat(f.cantidad || 0), 0);
  const total = fields.reduce((sum, f) => sum + parseFloat(f.total || 0), 0);

  setTotalPiezas(piezas);
  setTotalGeneral(total);
};


  const options = inventarios.map((option) => {
    const junta = option.codigo;
    const firstLetter = option.codigo[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  const options2 = clientes.map((option) => {
    const junta = option.nombre_comercial;
    const firstLetter = option.nombre_comercial[0].toUpperCase();
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
      junta,
    };
  });

  return (
    <>
      <Header />
      <br />
      <br />
      {user.pedidos_create ? (
        <div className="card container col-12">
          <h3 align="center">Nueva Venta Saldero</h3>
          <Form onSubmit={savePedido}>
            <Row>
              <Col md={2}>
                <Label>Almacen</Label>
              <Input
                                  type="select"
                                  value={selectedArea}
                                  onChange={(e) => {
                                    setSelectedArea(e.target.value);
                                  }}
                                >
                                  <option value="">Selecciona un Almacen</option>
                                  {areas
                                    .sort((a, b) => (a.name > b.name ? 1 : -1))
                                    .map((a) => {
                                      if(a.name != "General"){
                                      return (
                                        <option value={a._id}>
                                          {a.name}
                                        </option>
                                      );
                                    }
                                    })
                                    }
                                </Input>
              </Col>
              <Col md={2}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  onChange={(e) => {
                    setFecha(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Sociedad</Label>
                <Input
                  className="col-sm-12"
                  type="select"
                  value={selectedSociedad}
                  required
                  onChange={(e) => {
                    setSelectedSociedad(e.target.value);
                  }}
                >
                  <option value="0">Selecciona un Sociedad</option>
                  {sociedades
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </Col>
              <Col md={2}>
                              <Label className="mr-sm-2">Cliente</Label>
                              <Autocomplete
                                size="small"
                                value={value}
                                onChange={(event, selectedCliente) => {
                                  setValue(selectedCliente);
                                }}
                                options={options2.sort(
                                  (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
                                )}
                                groupBy={(option) => option.firstLetter}
                                getOptionLabel={(option) => option.junta}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Selecciona"
                                    variant="outlined"
                                  />
                                )}
                                renderOption={(option) => (
                                  <React.Fragment>{option.nombre_comercial}</React.Fragment>
                                )}
                              />
                            </Col>

              <Col md={2}>
                <Label>Vendedor</Label>
                <Input
                  type="select"
                  value={selectedColaborador}
                  onChange={(e) => {
                    setSelectedColaborador(e.target.value);
                  }}
                >
                  <option value="">Selecciona un Vendedor</option>
                  {colaboradores
                    .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                    .map((a) => {
                        return (
                          <option value={a._id}>
                            {a.nombre} {a.apellido}
                          </option>
                        );
                    })}
                </Input>
              </Col>
              {/* <Col md={2}>
                <Label>Fecha Cancelacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha Cancelacion"
                  value={fecha_cancelacion}
                  required
                  onChange={(e) => {
                    setFechaCancelacion(e.target.value);
                    let inicio = new Date(e.target.value)
                    let bla = inicio.setDate(inicio.getDate()-45);
                    setFechaConfirmacion(moment(bla).format("YYYY-MM-DD"))
                  }}
                />
              </Col> */}
            </Row>
            <Row>
              <Col md={2}>
                <Label>Fecha Confirmacion</Label>
                <Input
                  type="date"
                  placeholder="Fecha Confirmacion"
                  value={fecha_confirmacion}
                  required
                  disabled
                />
              </Col>
            <Col md={2}>
                    <Label className="mr-sm-2">Empresa</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(e) => {
                        setSelectedEmpresa(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {empresas
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col>
                  {/* <Col md={2}>
                    <Label className="mr-sm-2">Comprador</Label>
                    <Input
                      className="col-sm-12"
                      type="select"
                      value={selectedComprador}
                      required
                      onChange={(e) => {
                        setSelectedComprador(e.target.value);
                      }}
                    >
                      <option value="0">Selecciona</option>
                      {compradores
                        .sort((a, b) => (a.name > b.name ? 1 : -1))
                        .map((a) => {
                          return <option value={a._id}>{a.name}</option>;
                        })}
                    </Input>
                  </Col> */}
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
              <Col md={2}>
                              <Label>Impuestos</Label>
                              <Input
                                type="select"
                                value={selectedImpuesto}
                                onChange={(e) => {
                                  setSelectedImpuesto(e.target.value);
                                }}
                              >
                                <option value={0}>No</option>
                                <option value={16}>Si</option>
                              </Input>
                            </Col>
            </Row>
            <Row>
              {/* <Col md={3}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Pedido Cliente
                </Label>
                <Input
                  type="text"
                  placeholder="Pedido Cliente"
                  value={pedidoCliente}
                  required
                  onChange={(e) => {
                    setPedidoCliente(e.target.value);
                  }}
                />
              </Col> */}
            </Row>
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>

            {/* Tabla Articulos */}

            <Row>
              <Col md={2}>
                <Label className="mr-sm-2">Selecciona</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Articulos</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Talla</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Color</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Cantidad</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Precio</Label>
              </Col>
              <Col md={2}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>

{inputFields.map((inputField) => {
// Buscar en los inventarios todas las combinaciones disponibles para ese artículo
  const articuloSeleccionado = inventarios.find(
    (a) => a.idArticulo === inputField.articulos
  );

  const combinaciones = articuloSeleccionado?.combinaciones || [];

  const tallasDisponibles = [...new Set(
    combinaciones.map((c) => c.idTalla)
  )];

  const coloresDisponibles = [...new Set(
    combinaciones.map((c) => c.idColor)
  )];

  return (
    <div key={inputField.id}>
      <Row>
        <Col md={2}>
          <Autocomplete
            size="small"
            value={inputField.articulosNombre}
            onChange={(event, selectedArticulo) => {
              BuscaArticulo(inputField.id, selectedArticulo);
            }}
            options={options.sort(
              (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
            )}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option.junta}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Selecciona"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <React.Fragment>
                {option.codigo}
              </React.Fragment>
            )}
          />
        </Col>

        <Col md={2}>
          <Input
            name="articulo"
            type="string"
            placeholder="Articulo"
            value={inputField.articulosNombre}
            disabled
          />
        </Col>

<Col md={1}>
  <Input
    name="tallas"
    type="select"
    value={inputField.tallas}
    required
    onChange={(event) => handleChangeInput(inputField.id, event)}
  >
    <option value="">Selecciona</option>
    {tallas
      .filter((t) => tallasDisponibles.includes(t._id))
      .map((t) => (
        <option key={t._id} value={t._id}>
          {t.name}
        </option>
      ))}
  </Input>
</Col>
<Col md={1}>
  <Input
    name="colores"
    type="select"
    value={inputField.colores}
    required
    onChange={(event) => handleChangeInput(inputField.id, event)}
  >
    <option value="">Selecciona</option>
    {colores
      .filter((c) => coloresDisponibles.includes(c._id))
      .map((c) => (
        <option key={c._id} value={c._id}>
          {c.name}
        </option>
      ))}
  </Input>
</Col>
        <Col md={1}>
          <Input
            name="cantidad"
            type="number"
            min="0"
            step="any"
            placeholder="Cantidad"
            value={inputField.cantidad}
            required
            onChange={(event) => handleChangeInput(inputField.id, event)}
          />
           <small className="text-muted">
    Disponible: {inputField.disponible ?? 0}
  </small>
        </Col>

        <Col md={1}>
          <Input
            name="precio"
            type="number"
            min="0"
            step="any"
            placeholder="Precio"
            value={inputField.precio}
            required
            onChange={(event) => handleChangeInput(inputField.id, event)}
          />
        </Col>

        <Col md={2}>
          <Input
            name="total"
            type="number"
            min="0"
            step="any"
            placeholder="Total"
            value={inputField.total}
            disabled
          />
        </Col>

        <Col>
          <Button
            size="sm"
            className="btn"
            color="danger"
            disabled={inputFields.length === 1}
            onClick={() => handleRemoveFields(inputField.id)}
            tabIndex="-1"
          >
            <i className="fas fa-minus"></i>
          </Button>{" "}
          <Button
            size="sm"
            className="btn"
            color="info"
            onClick={handleAddFields}
            tabIndex="-1"
          >
            <i className="fas fa-plus"></i>
          </Button>
        </Col>
      </Row>
    </div>
  );
})}

          
            <Row>
              <Col md={10}>
                <h4 id="logoutBoton">
                  TOTALES {total_piezas} pzas. /{" "}
                  {"$" + new Intl.NumberFormat("en-US").format(total_general)}
                </h4>
              </Col>
            </Row>
            {/* Termina Tabla Articulos */}

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoPedidos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios minutos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default VentaSalderos;
